import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-i-casino',
  templateUrl: './i-casino.component.html',
  styleUrls: ['./i-casino.component.css']
})
export class ICasinoComponent implements OnInit {

  @ViewChild('parentTabs', { static: false }) parentTabs?: TabsetComponent;
  @ViewChild('childTabs', { static: false }) childTabs?: TabsetComponent;

  modalRef?: BsModalRef;
  public api = api;
  public env = environment;
  public data: any;
  public iframeUrl: any = '';
  public gameName: any = '';

  constructor(public service: WebserviceService,
    public _shared: SharedService,
    public _common: CommonService,
    private _message: MessageService,
    public router: Router,
    protected actRoute: ActivatedRoute,
    private modalService: BsModalService) { }

  ngOnInit(): void {
    // this._shared.sharedTabCasinoI.subscribe((data: any) => {
    //   if (data)
    //     this.getData();
    // });
    this.getData();
  }

  tabId = 0;
  onSelect(id: any): void {
    this.tabId = id;
    if (this.childTabs?.tabs[this.tabId]) {
      this.childTabs.tabs[this.tabId].active = true;
    }
  }
  pTabId = 0;
  onSelectParent(id: any): void {
    this.pTabId = id;
    if (this.parentTabs?.tabs[this.pTabId]) {
      this.parentTabs.tabs[this.pTabId].active = true;
    }
    this.onSelect(0);
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.getServices().Get(`${this.env.baseUrl + this.api.casinoIList}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.setICasino(res);
          //this.setICasinoNew(res);
          // this.setIntCasino(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  setICasino(res: any) {
    let allDt: any[] = [];
    let allDtGameTyes: any[] = [];
    let dt: any[] = [];
    Object.keys(res.data.providers).forEach((key) => {
      let dataDt: any[] = [];
      let allDataDtInner: any[] = [];
      Object.keys(res.data.providers[key]).forEach((key1) => {
        allDataDtInner = [...allDataDtInner, ...res.data.providers[key][key1]];
        allDt = [...allDt, ...res.data.providers[key][key1]];
        dataDt.push({
          'name': key1,
          'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
          'data': res.data.providers[key][key1]
        });
      });
      dataDt.unshift({ name: 'all', slug: 'all', data: allDataDtInner });
      dt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': dataDt
      });
    });
    allDtGameTyes = allDt.map(item => item.game_type);
    const uniqueSet = new Set(allDtGameTyes);
    allDtGameTyes = [...uniqueSet];

    let finalAllDt: any[] = [];
    allDtGameTyes.forEach(element => {
      finalAllDt.push({
        'name': element,
        'slug': element.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': allDt.filter(e => e.game_type == element)
      });
    });

    dt.unshift({ name: 'all', slug: 'all', data: finalAllDt });
    res.data.providers = dt;
    this.data = res.data.providers;

  }

  // setICasino(res: any) {

  //   // let dt: any[] = [];
  //   // Object.keys(res.data.tables).forEach((key) => {
  //   //   let dataDt: any[] = [];
  //   //   Object.keys(res.data.tables[key]).forEach((key1) => {
  //   //     dataDt.push({
  //   //       'name': key1,
  //   //       'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
  //   //       'data': res.data.tables[key][key1]
  //   //     });
  //   //   });
  //   //   dt.push({
  //   //     'name': key,
  //   //     'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
  //   //     'data': dataDt
  //   //   });
  //   // });
  //   // res.data.tables = dt;
  //   // this.data = res.data;

  //   if (res.data.providers) {
  //     res.data['tables'] = res.data.providers;
  //   }

  //   let dt: any[] = [];
  //   Object.keys(res.data.tables).forEach((key) => {
  //     let dataDt: any[] = [];
  //     Object.keys(res.data.tables[key]).forEach((key1) => {
  //       dataDt.push({
  //         'name': key1,
  //         'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
  //         'data': res.data.tables[key][key1]
  //       });
  //     });
  //     dt.push({
  //       'name': key,
  //       'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
  //       'data': dataDt
  //     });
  //   });
  //   res.data.tables = dt;
  //   this.data = res.data;
  // }

  setICasinoNew(res: any) {
    let allDt: any[] = [];
    Object.keys(res.data.allTables).forEach((key) => {
      allDt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': res.data.allTables[key]
      });
    });
    let dt: any[] = [];
    Object.keys(res.data.tables).every((key) => {
      let dataDt: any[] = [];
      Object.keys(res.data.tables[key]).forEach((key1) => {
        let dataDtInner: any[] = [];
        let allDataDtInner: any[] = [];
        Object.keys(res.data.tables[key][key1]).forEach((key2) => {
          allDataDtInner = [...allDataDtInner, ...res.data.tables[key][key1][key2]]
          dataDtInner.push({
            'name': key2,
            'slug': key2.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
            'data': res.data.tables[key][key1][key2]
          });
        });
        // console.log(allDataDtInner);
        dataDtInner.unshift({ name: 'all', slug: 'all', data: allDataDtInner });

        dataDt.push({
          'name': key1,
          'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
          'data': dataDtInner
        });
      });
      dt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': dataDt
      });
      return false; // break (break foreach loop after first iteration)
    });
    res.data.tables = dt;
    this.data = res.data.tables[0]['data'];
    this.data.unshift({ name: 'all', slug: 'all', data: allDt });
  }

  setIntCasino(res: any) {

    let allDt: any[] = [];
    Object.keys(res.data.allTables).forEach((key) => {
      allDt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': res.data.allTables[key]
      });
    });

    //console.log(res.data.tables);
    let dt: any[] = [];
    Object.keys(res.data.tables).forEach((key) => {
      let dataDt: any[] = [];
      Object.keys(res.data.tables[key]).forEach((key1) => {
        let dataDtInner: any[] = [];
        let allDataDtInner: any[] = [];
        Object.keys(res.data.tables[key][key1]).forEach((key2) => {
          allDataDtInner = [...allDataDtInner, ...res.data.tables[key][key1][key2]]
          dataDtInner.push({
            'name': key2,
            'slug': key2.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
            'data': res.data.tables[key][key1][key2]
          });
        });
        // console.log(allDataDtInner);
        dataDtInner.unshift({ name: 'all', slug: 'all', data: allDataDtInner });

        dataDt.push({
          'name': key1,
          'slug': key1.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
          'data': dataDtInner
        });
      });
      dt.push({
        'name': key,
        'slug': key.toLocaleLowerCase().replace(/\./g, '').replace(/\s/g, '-'),
        'data': dataDt
      });
    });
    res.data.tables = dt;
    this.data = res.data.tables[0]['data'];
    this.data.unshift({ name: 'all', slug: 'all', data: allDt });
    //console.log(this.data);
  }

  openModal(template: TemplateRef<any>, item: any, name: any) {
    this.getServices().Get(`${this.env.baseUrl + this.api.casinoITbl}/${item.game_id}/${item.game_code}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.iframeUrl = this._common.secureUrl(res.data.iframe);
          this.gameName = name;

          this.modalRef = this.modalService.show(template,
            Object.assign({}, { class: 'ctm-modal-xl modalUI' }));
        }
      },
      (err) => {
        console.log(err);
      });

  }

  confirmBox(item: any, name: any) {

    let msg = `Profit & amp; Loss in iCasino would be ${item?.multiplier} times.It means, if you WIN 1, your Account Statement would be Credited as ${item?.multiplier} and similarly if you LOSE 1, your Account Statement would be Debited as ${item?.multiplier}. <br> Please note(1 Point = ${item?.multiplier} Points) <br> कृपया ध्यान दें(1 अंक = ${item?.multiplier} अंक)`;
    Swal.fire({
      title: 'DO YOU AGREE?',
      html: msg,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, I Agree',
      cancelButtonText: 'No, I dont Agree'
    }).then((result) => {
      if (result.value) {
        this.router.navigate(['/casino-detail', 99995, item.id]);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    })
  }

  closeModal() {
    this.modalRef?.hide();
    this.iframeUrl = '';
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

}
